import React from 'react';
import { Ornament } from './Ornament';
import { Reveal } from './Reveal';
import { SCHEDULE } from '../data/invitation';
export function Schedule() {
  return <section className="w-full bg-paper-100 px-6 py-24 sm:px-10 sm:py-32 lg:px-16" data-id="element-100" data-mp="mc40v92l03es">
      <div className="mx-auto max-w-5xl" data-id="element-101" data-mp="r5oxoxsfurce">
        <Reveal data-id="element-102" data-mp="w3qf7ea7uilr">
          <div className="flex items-baseline justify-between border-b border-ink-900/10 pb-4" data-id="element-103" data-mp="w49rofh3kese">
            <p className="text-[0.65rem] uppercase tracking-label text-ink-400" data-id="element-104" data-mp="3umfca1236cpp">Potek dneva</p>
            <p className="font-serif text-sm italic text-ink-400" data-id="element-105" data-mp="3ej8vt4isopy">dva dela, en dan</p>
          </div>
        </Reveal>

        <div className="mt-12 grid gap-px overflow-hidden border border-ink-900/10 bg-ink-900/10 lg:grid-cols-2" data-id="element-106" data-mp="8dmebeoewwyg">
          {SCHEDULE.map((m, i) => <Reveal key={m.time} delay={i * 0.06} className="h-full" data-id="element-107" data-mp="1jtksfwyg696j" data-mpi={i}>
              <article className="relative flex h-full flex-col overflow-hidden bg-paper-50 p-8 sm:p-12" data-id="element-108" data-mp="1jtb40dt1wa2y">
                <span aria-hidden="true" className="pointer-events-none absolute -bottom-8 right-2 select-none font-serif text-[9rem] font-light leading-none text-ink-900/[0.04]" data-id="element-109" data-mp="1ourztuwoh6co">
                  {m.index}
                </span>
                <p className="relative text-[0.65rem] uppercase tracking-label text-accent-500" data-id="element-110" data-mp="141if56w850gw">
                  {m.index} del
                </p>
                <p className="relative mt-6 font-serif text-6xl font-light leading-none text-ink-900 sm:text-7xl" data-id="element-111" data-mp="u5p63xhprp3v">
                  {m.time}
                </p>
                <h2 className="relative mt-4 font-serif text-2xl font-light italic text-ink-800 sm:text-3xl" data-id="element-112" data-mp="pcchvogy5kbn">
                  {m.title}
                </h2>
                <p className="relative mt-6 font-serif text-lg leading-relaxed text-ink-700 sm:text-xl" data-id="element-113" data-mp="gesgmfj33o11">
                  {m.text}
                </p>
                {m.note && <p className="relative mt-auto border-t border-dotted border-ink-900/20 pt-6 text-sm italic leading-relaxed text-ink-500" data-id="element-114" data-mp="6f1mieyfrb1h">
                    {m.note}
                  </p>}
              </article>
            </Reveal>)}
        </div>

        <Reveal delay={0.1} data-id="element-115" data-mp="3iz723evq42v6">
          <Ornament className="mt-16" data-id="element-116" data-mp="3izyygrx5a4mi" />
          <p className="mx-auto mt-10 max-w-2xl text-center font-serif text-2xl font-light italic leading-snug text-ink-900 sm:text-3xl" data-id="element-117" data-mp="3j10bh1xq116v">
            Za hrano in pijačo bo poskrbljeno. Za razplet večera nekoliko manj.
          </p>
        </Reveal>
      </div>
    </section>;
}